import FormControl from '@mui/material/FormControl';
import { Autocomplete } from 'components/shared/index';
import useNavParams from 'hooks/useNavParams';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEditPageContext } from '../EditPageContext';

import type { FC } from 'react';
import type { InnerViewNavigatorProps } from '../EditPage.types';

interface Option {
  id: any;
  label: string;
}

const createLabelFromStringArray = (navigatorLabelGetter, obj) => {
  const labelArray: string[] = [];

  if (navigatorLabelGetter) {
    navigatorLabelGetter.forEach((getter) => {
      const value = get(obj, getter);
      labelArray.push(value);
    });
  }

  return labelArray.join(' - ');
};

const DEFAULT_NAVIGATOR_VALUE_GETTER = 'code';
const DEFAULT_NAVIGATOR_LABEL_GETTER: string[] = ['code'];

const InnerViewNavigator: FC<InnerViewNavigatorProps> = ({
  setCurrentView,
  views,
  currentView,
  navigatorValueGetter = DEFAULT_NAVIGATOR_VALUE_GETTER,
  navigatorLabelGetter = DEFAULT_NAVIGATOR_LABEL_GETTER
}) => {
  'use memo';

  const { t } = useTranslation('common');
  const { params } = useNavParams();
  const { isEditable } = useEditPageContext();
  const [options, setOptions] = useState<Option[]>([]);
  const defaultItem = {
    id: currentView ? currentView[navigatorValueGetter] : '',
    label: createLabelFromStringArray(navigatorLabelGetter, currentView)
  };

  useEffect(() => {
    if (views) {
      const options = views.map((item) => {
        return {
          id: item[navigatorValueGetter],
          label: createLabelFromStringArray(navigatorLabelGetter, item)
        };
      });
      setOptions(options);
    }
  }, [views, navigatorValueGetter, navigatorLabelGetter]);

  const onSelected = (selected: Option | null) => {
    const selectedView = views?.find(
      (item) => item[navigatorValueGetter] === selected?.id
    );
    setCurrentView(selectedView);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <FormControl variant="standard" sx={{ minWidth: 120 }}>
        <Autocomplete
          variant="outlined"
          disabled={isEditable}
          disableClearable={true}
          value={defaultItem}
          options={options}
          idProperty="id"
          label={t(`tableTabs.${params?.page.toUpperCase()}`)}
          onSelected={onSelected}
        />
      </FormControl>
    </div>
  );
};

export default InnerViewNavigator;
